import type { ViewModel } from "./ViewModel";
import { userInfo } from "../../../repositories/companyRepository";

export default function getViewModelNewValues(): ViewModel {
  const r: ViewModel = {
    customerRepName: "",
    customerRepEMail: userInfo.eMail,
    customerRepPhone: userInfo.phoneNumber,
    comments: "",
    salesDocument: null,
    items: [],
    attachments: [],
    };
    
  return r;
}
